// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const ur: ChromeTranslations = {
  'nav.nextPage': '← اگلا صفحہ',
  'nav.previousPage': 'پچھلا صفحہ →',
  'nav.continueToLevel': '← مرحلے کی طرف جاری رکھیں',
  'nav.backToMenu': '← مینو پر واپس',
  'howto.page': '{total} میں سے صفحہ {n}',
  'options.title': 'اختیارات',
  'ui.language': 'زبان',
};
